import src from "IMAGE";
export default { src, width: 1024, height: 360, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAIUlEQVR42n3KMQEAAAiEwKeXRe1oCLUAwzERoEwubX4Ys/qCDlEn3mKNAAAAAElFTkSuQmCC"};
